import type { NotificationsFeatureConfig } from './type';

export const config: NotificationsFeatureConfig = {
    filterNotificationTypes: [],
};
